import { createSlice } from '@reduxjs/toolkit'

const initialState = {
   notifications: [
      {
         id: 1,
         heading: 'New device has been authorized',
         description:
            'You have successfully authorized a new device or in new location to sign into your WSN account.',
         isRead: false,
         createdAt: '2021-07-30T14:20:42.562Z',
      },
      {
         id: 2,
         heading: 'New device has been authorized',
         description:
            'You have successfully authorized a new device or in new location to sign into your WSN account.',
         isRead: false,
         createdAt: '2021-07-30T14:20:42.562Z',
      },
      {
         id: 3,
         heading: 'New device has been authorized',
         description:
            'You have successfully authorized a new device or in new location to sign into your WSN account.',
         isRead: false,
         createdAt: '2021-07-30T14:20:42.562Z',
      },
   ],
}

// const sample = {
//    id: 1,
//    heading: 'New device has been authorized',
//    description:
//       'You have successfully authorized a new device or in new location to sign into your WSN account.',
//    isRead: false,
//    createdAt: '2021-07-30T14:20:42.562Z',
// }

export const notificationsSlice = createSlice({
   name: 'notifications',
   initialState,
   reducers: {
      addNotification: (state, action) => {
         state.notifications.push({
            ...action.payload,
            isRead: false,
            id: Math.ceil(Math.random() * 10000),
            createdAt: new Date().toISOString(),
         })
      },
      markRead: (state, action) => {
         state.notifications = state.notifications.map(n => {
            if (n.id === action.payload) {
               return { ...n, isRead: true }
            }
            return n
         })
      },
      markAllRead: state => {
         state.notifications = state.notifications.map(n => ({
            ...n,
            isRead: true,
         }))
      },
      deleteNotifications: (state, action) => {
         state.notifications = state.notifications.filter(
            n => !action.payload.includes(n.id)
         )
      },
   },
})

export const { addNotification, markRead, markAllRead, deleteNotifications } =
   notificationsSlice.actions

export default notificationsSlice.reducer
